import { render, staticRenderFns } from "./Votacao.vue?vue&type=template&id=ebed4e88&scoped=true"
import script from "./Votacao.vue?vue&type=script&lang=js"
export * from "./Votacao.vue?vue&type=script&lang=js"
import style0 from "./Votacao.vue?vue&type=style&index=0&id=ebed4e88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebed4e88",
  null
  
)

export default component.exports